import React from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';

const InactivePage = () => {
    return (
        <Container fluid className="h-100 mt-5 pt-5">
            <Row className="justify-content-center align-items-center h-100">
                <Col md={6}>
                    <Card className="shadow-sm">
                        <Card.Body className="p-5 text-center">
                            <h2 className="text-warning mb-4">Account Disattivato</h2>
                            <p className="mb-5 text-muted">
                                Il tuo abbonamento a SportID Manager è stato disattivato o rimborsato. 
                                Per ripristinare l'accesso, contatta il nostro team di supporto.
                            </p>
                            <Button 
                                variant="outline-primary" 
                                size="lg" 
                                href="mailto:supporto@sportid.it"
                            >
                                Contatta il Supporto
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default InactivePage;